import React, { useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

const MAX_LENGTH = 255

const PortfolioOwnerDialog = ({ open, value, onClose, onSave }) => {
  const [draft, setDraft] = useState(value || '')
  const [error, setError] = useState(null)
  const inputRef = useRef(null)

  useEffect(() => {
    if (open) {
      setDraft(value || '')
      setError(null)
    }
  }, [open, value])

  const save = () => {
    const trimmed = draft.trim()
    if (trimmed.length > MAX_LENGTH) {
      setError(`Please keep this under ${MAX_LENGTH} characters.`)
      return
    }
    onSave(trimmed || null)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs' fullWidth TransitionProps={{ onEntered: () => inputRef.current?.focus() }}>
      <DialogTitle>Who owns this portfolio?</DialogTitle>
      <DialogContent>
        <Label htmlFor='portfolio-owner-organisation'>Owner</Label>
        <Input
          id='portfolio-owner-organisation'
          ref={inputRef}
          value={draft}
          maxLength={MAX_LENGTH}
          onChange={e => setDraft(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); save() } }}
          placeholder='e.g. Harbour Property Group'
          aria-invalid={!!error}
          aria-describedby='portfolio-owner-organisation-help'
        />
        <Help id='portfolio-owner-organisation-help'>
          The organisation or organisations that own the buildings in this portfolio. It is shown on the portfolio overview and does not give anyone access. Leave it empty to remove it.
        </Help>
        {error && <ErrorText role='alert'>{error}</ErrorText>}
      </DialogContent>
      <DialogActions>
        <CancelButton type='button' onClick={onClose}>Cancel</CancelButton>
        <SaveButton type='button' onClick={save}>Save owner</SaveButton>
      </DialogActions>
    </Dialog>
  )
}

export default PortfolioOwnerDialog

const Label = styled.label`
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #344054;
`

const Input = styled.input`
  width: 100%;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  font: inherit;
  font-size: 16px;
  color: #0c1229;
  box-sizing: border-box;
  &:focus { outline: 2px solid #33becc; outline-offset: 0; border-color: transparent; }
  &[aria-invalid='true'] { border-color: #b00020; }
`

const Help = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: #475467;
`

const ErrorText = styled.p`
  margin: 8px 0 0;
  font-size: 14px;
  color: #b00020;
`

const SaveButton = styled.button`
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid ${({ theme }) => theme.colors.secondary};
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.secondary};
  color: #fff;
  font: inherit;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  &:focus-visible { outline: 2px solid #0c1229; outline-offset: 2px; }
`

const CancelButton = styled.button`
  min-height: 40px;
  padding: 0 16px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background: #fff;
  color: #0c1229;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  &:focus-visible { outline: 2px solid #33becc; outline-offset: 2px; }
`
